export default "__VITE_ASSET__Dkth1GEo__"